/**
 * Custom price section component for additional charges or discounts
 */

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "@/hooks/useTranslation";

interface CustomPriceSectionProps {
  vlastnaCena: number;
  vlastnyPopis: string;
  onPriceChange: (value: number) => void;
  onDescriptionChange: (value: string) => void;
}

export function CustomPriceSection({
  vlastnaCena,
  vlastnyPopis,
  onPriceChange,
  onDescriptionChange,
}: CustomPriceSectionProps) {
  const { t } = useTranslation(); // Add translation hook

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold">
        {t("attendance:dialog.customPrice")}
      </h3>
      <div className="space-y-2">
        <Label htmlFor="vlastnaCena">
          {t("attendance:dialog.customPriceAmount")}
        </Label>
        <Input
          id="vlastnaCena"
          type="number"
          step="0.01"
          value={vlastnaCena}
          onChange={e => onPriceChange(Number(e.target.value))}
          placeholder="0.00"
        />
        <p className="text-xs text-muted-foreground">
          {t("attendance:dialog.customPriceHint")}
        </p>
      </div>

      {vlastnaCena !== 0 && (
        <div className="space-y-2">
          <Label htmlFor="vlastnyPopis">
            {t("attendance:dialog.customPriceDescription")}
          </Label>
          <Textarea
            id="vlastnyPopis"
            value={vlastnyPopis}
            onChange={e => onDescriptionChange(e.target.value)}
            placeholder={t("attendance:dialog.customPricePlaceholder")}
            rows={3}
            required={vlastnaCena !== 0}
          />
        </div>
      )}
    </div>
  );
}
